import { render, staticRenderFns } from "./ButtonTab.vue?vue&type=template&id=057e046a&scoped=true&"
import script from "./ButtonTab.vue?vue&type=script&lang=js&"
export * from "./ButtonTab.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTab.vue?vue&type=style&index=0&id=057e046a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057e046a",
  null
  
)

export default component.exports